/**
 * App entry point — initializes Sentry, renders React app
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initSentry } from './utils/sentry';
import '@fontsource-variable/inter';
import '@fontsource-variable/petrona';
import './styles/main.css';

// Initialize error tracking before React renders
initSentry();

// Dev-only accessibility scanner — logs violations to browser console
if (import.meta.env.DEV) {
  import('@axe-core/react').then((axe) => {
    axe.default(React, ReactDOM, 1000);
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
